/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GameSettingsEntity } from '../models/GameSettingsEntity';
import type { GameSettingsResponse } from '../models/GameSettingsResponse';
import type { GetManyGameSettingsEntityResponseDto } from '../models/GetManyGameSettingsEntityResponseDto';
import type { SaveGameSettingsDto } from '../models/SaveGameSettingsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import { GamePositionDto } from '@/api/generated-client/models/GamePositionDto';
export class GamesSettingsApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Save a single game settings
   * @returns GameSettingsResponse
   * @throws ApiError
   */
  public saveGameSettings({
    requestBody,
  }: {
    requestBody: SaveGameSettingsDto,
  }): CancelablePromise<GameSettingsResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/games-settings/save',
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Retrieve a single game settings
   * @returns GameSettingsEntity Get one base response
   * @throws ApiError
   */
  public getOneGameSettings({
    id,
    fields,
    join,
    cache,
  }: {
    id: number,
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<GameSettingsEntity> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games-settings/{id}',
      path: {
        'id': id,
      },
      query: {
        'fields': fields,
        'join': join,
        'cache': cache,
      },
    });
  }
  /**
   * Delete a single game settings
   * @returns any Delete one base response
   * @throws ApiError
   */
  public deleteOneGameSettings({
    id,
  }: {
    id: number,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/games-settings/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Retrieve multiple game settings
   * @returns any Get many base response
   * @throws ApiError
   */
  public getGameSetting({
    fields,
    s,
    filter,
    or,
    sort,
    join,
    limit,
    offset,
    page,
    cache,
  }: {
    /**
     * Selects resource fields. <a href="https://github.com/nestjsx/crud/wiki/Requests#select" target="_blank">Docs</a>
     */
    fields?: Array<string>,
    /**
     * Adds search condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#search" target="_blank">Docs</a>
     */
    s?: string,
    /**
     * Adds filter condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#filter" target="_blank">Docs</a>
     */
    filter?: Array<string>,
    /**
     * Adds OR condition. <a href="https://github.com/nestjsx/crud/wiki/Requests#or" target="_blank">Docs</a>
     */
    or?: Array<string>,
    /**
     * Adds sort by field. <a href="https://github.com/nestjsx/crud/wiki/Requests#sort" target="_blank">Docs</a>
     */
    sort?: Array<string>,
    /**
     * Adds relational resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#join" target="_blank">Docs</a>
     */
    join?: Array<string>,
    /**
     * Limit amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#limit" target="_blank">Docs</a>
     */
    limit?: number,
    /**
     * Offset amount of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#offset" target="_blank">Docs</a>
     */
    offset?: number,
    /**
     * Page portion of resources. <a href="https://github.com/nestjsx/crud/wiki/Requests#page" target="_blank">Docs</a>
     */
    page?: number,
    /**
     * Reset cache (if was enabled). <a href="https://github.com/nestjsx/crud/wiki/Requests#cache" target="_blank">Docs</a>
     */
    cache?: number,
  }): CancelablePromise<(GetManyGameSettingsEntityResponseDto | Array<GameSettingsEntity>)> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/games-settings',
      query: {
        'fields': fields,
        's': s,
        'filter': filter,
        'or': or,
        'sort': sort,
        'join': join,
        'limit': limit,
        'offset': offset,
        'page': page,
        'cache': cache,
      },
    });
  }
}
